import IOriginationContextRequest from "./IOriginationContextRequest";
import IOriginationChannel from "./IOriginationChannel";
import OriginationChannel from "./OriginationChannel";

export default class OriginationContextRequest implements IOriginationContextRequest {
    constructor(
        public channel: IOriginationChannel = new OriginationChannel(),
        public sourceId?: string,
    ) {
    }
}
